module.exports = __webpack_public_path__ + "img/ltkbaby-2x.5de3086.jpg";